import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';

export let updateEditIsSaving = mutatorAction('updateEditIsSaving', (isSaving: boolean) => {
    let store = connectedAccountsStore();
    store.editAccountState.isSaving = isSaving;
});
